import { useState } from "react";
import { ChevronRight, FileText, FileWarning } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { DatasheetViewer, fmtSize } from "./DatasheetViewer";

const mb = (b) => (b ? ` · ${fmtSize(b)}` : "");

function DatasheetList({ sheets, open, onClose, onPick, testid }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#18181B] border-zinc-800 text-zinc-100" data-testid={`${testid}-list`}>
        <DialogTitle className="text-[15px] font-bold">Datenblätter zur Auswahl</DialogTitle>
        <DialogDescription className="text-[12px] text-zinc-400 -mt-2">Antippen zum Anzeigen</DialogDescription>
        <div className="space-y-1.5">
          {sheets.map((s) => (
            <button
              key={s.path}
              type="button"
              onClick={() => onPick(s)}
              data-testid={`${testid}-item-${s.component_id}`}
              className="w-full text-left rounded-xl border border-zinc-800 bg-[#0F0F11] hover:border-[#00E575]/60 px-3 py-2.5 flex items-center gap-3 transition-colors"
            >
              <FileText size={16} className="text-[#00E575] shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="text-[13px] font-semibold truncate">{s.title}</div>
                <div className="text-[11px] text-zinc-500 truncate">{s.filename}{mb(s.size_bytes)}</div>
              </div>
              <ChevronRight size={15} className="text-zinc-500 shrink-0" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

// „Datenblatt zeigen“ – 1 Datenblatt öffnet direkt, mehrere zuerst eine Auswahl.
export function DatasheetButton({ sheets = [], missing = [], testid = "datasheet-btn" }) {
  const [listOpen, setListOpen] = useState(false);
  const [active, setActive] = useState(null);
  if (!sheets.length && !missing.length) return null;
  if (!sheets.length) {
    return (
      <span
        data-testid={`${testid}-missing`}
        title={`Kein Datenblatt im Katalog hinterlegt: ${missing.join(", ")}`}
        className="h-9 px-3 rounded-lg border border-dashed border-zinc-700 text-zinc-500 text-[12px] font-semibold inline-flex items-center gap-1.5"
      >
        <FileWarning size={14} /> Kein Datenblatt hinterlegt
      </span>
    );
  }
  const open = () => (sheets.length === 1 ? setActive(sheets[0]) : setListOpen(true));
  return (
    <>
      <button
        type="button"
        onClick={open}
        data-testid={testid}
        className="h-9 px-3 rounded-lg bg-[#00E575]/12 border border-[#00E575]/50 text-[#00E575] text-[12.5px] font-bold inline-flex items-center gap-1.5 hover:bg-[#00E575]/20 active:scale-95 transition-transform"
      >
        <FileText size={14} /> Datenblatt zeigen{sheets.length > 1 ? ` (${sheets.length})` : ""}
      </button>
      <DatasheetList
        sheets={sheets}
        open={listOpen}
        onClose={() => setListOpen(false)}
        onPick={(s) => { setListOpen(false); setActive(s); }}
        testid={testid}
      />
      <DatasheetViewer sheet={active} onClose={() => setActive(null)} />
    </>
  );
}
